const promotionDomains = {
  computed: {
    promotionTypesEnum() {
      return {
        PRICE: 'Price',
        SPEND_AND_GET: 'SpendAndGet',
      }
    },

    promotionTypesLabel() {
      const labels = {
        Price: this.$t('Preço'),
        SpendAndGet: this.$t('Compre por Valor e Ganhe'),
      }

      // Retorna um rótulo neutro (o próprio valor) para tipos não mapeados
      // (ex.: BuyAndGet), evitando quebra com registros existentes.
      return new Proxy(labels, {
        get(target, key) {
          if (key in target) {
            return target[key]
          }

          return key
        },
      })
    },
  },

  methods: {
    promotionTypes() {
      return [
        { value: 'Price', label: this.$t('Preço') },
        { value: 'SpendAndGet', label: this.$t('Compre por Valor e Ganhe') },
      ]
    },
  },
}

export default promotionDomains
